import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import naqdpayLoaderLogo from '@/assets/logos/naqdpay_loaderlogo.png';
import './azizi-loader.scss';
export function AziziLoader({ message = 'Loading...' }) {
    return (_jsxs("div", { className: "azizi-loader", role: "status", "aria-live": "polite", "aria-busy": "true", children: [_jsxs("div", { className: "azizi-loader__logo-wrap", children: [_jsx("span", { className: "azizi-loader__ring", "aria-hidden": true }), _jsx("img", { src: naqdpayLoaderLogo, alt: "Loading" })] }), _jsx("p", { children: message })] }));
}
